<template>
  <el-dialog title="Accept Job Role Matched" :visible="showModal" :show-close="false" width="600px" class="ts-modal">
    <p>
      By accepting this role match from company <u>{{ jobSeekerInfo.companyName }}</u>, they will be 
      notified that you accepted the role match and will be able to see your contact information.
    </p>
    <p>
      This way, they will be able to contact you and begin the interview process.    
    </p>
    &nbsp;&nbsp;
    <el-row :gutter="5">
      <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
        <button class="ts-btn ts-btn-small" style="float: right;" @click="acceptJobMatch">Accept</button>
      </el-col>
      <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
        <button class="ts-btn ts-btn-small ts-btn-white" style="float: left;" @click="onCloseDialog(null)">Cancel</button> 
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import * as signalR from '@aspnet/signalr';
export default {  
  created(){
      this.jobSeekerInfo = this.$route.params.data;
      
      //create signalR connection
      this.huburl = process.env.VUE_APP_MESSAGE_BASE_URI;
      this.connection = new signalR.HubConnectionBuilder().withUrl(this.huburl, { 
        transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling,
        'content-type': 'application/json',
        accessTokenFactory: () => localStorage.getItem('token') 
      }).build();

      this.connection.start().catch(function(err){
        return console.error(err.toString());
      });
      
    },
  data() {
    return {
      isLoading: false,
      showModal: true,
      jobSeekerInfo: {},
      connection : "",
      huburl: ""
    };
  },
  methods: {
    onCloseDialog(done) {
      this.showModal = false;
      this.$router.push({ name: 'jobseeker-statusboard', params: { activeTab: "first" }});
    },
    acceptJobMatch() {
      this.$store.dispatch('jobseeker/acceptInvite', this.jobSeekerInfo)
          .then((res) => {
            this.connection.invoke("SendMessageToAdmin", "Employee Added").catch(function(err){
              return console.error(err.toString());
            });
            this.$message.success('Invite Accepted!');
            this.$router.push({ name: 'jobseeker-statusboard', params: { activeTab: "first" }});            
          });
    },
  }
};
</script>